import * as React from "react";
import classnames from "classnames";
import { GoogleMaps } from "@grandvisionhq/common";
/* empty css                       */
const LocationSearchMap = ({
  className,
  labels,
  markers,
  activeLocation,
  mapOptions,
  highlightMarkerId,
  hovered,
  userLocation,
  userLocationZoomLevel,
  centerOnUserLocation,
  onClickUseMyLocation,
  onMarkerClick,
  onMarkerHover,
  onMapClick,
  center,
  markersUpdateConfig,
  id,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("location-search-map", className) }, /* @__PURE__ */ React.createElement("style", { jsx: true, global: true }, `
        .gm-style .gm-style-iw-t:after {
          display: none;
        }

        .gm-style .gm-style-iw-c .gm-ui-hover-effect {
          display: none !important;
        }
      `), /* @__PURE__ */ React.createElement(
  GoogleMaps,
  {
    id,
    center,
    labels: { shareCurrentLocation: labels.shareCurrentLocation },
    markers,
    highlightMarkerId,
    hovered,
    mapOptions,
    showUseMyLocation: true,
    userLocation,
    userLocationZoomLevel,
    centerOnUserLocation,
    markersUpdateConfig,
    onClickUseMyLocation,
    onMarkerClick,
    onMarkerHover,
    onMapClick
  }
), activeLocation && /* @__PURE__ */ React.createElement("div", { className: "location-search-map__active-location" }, activeLocation));
export {
  LocationSearchMap as default
};
//# sourceMappingURL=LocationSearchMap.js.map
